import { GridColDef } from '@mui/x-data-grid-pro'

export const bpLitterReportCols: GridColDef[] = [
  {
    flex: 2,
    headerName: 'Short Line Name',
    field: 'ShortLineName',
  },
  {
    flex: 1,
    headerName: 'Breeding Pair ID',
    field: 'BPID',
  },
  {
    flex: 1,
    headerName: 'Litter Seq.',
    field: 'LitterSeq',
  },
  {
    flex: 1,
    headerName: 'Location',
    field: 'RackName',
  },
]
